module.exports = __webpack_public_path__ + "assets/img/kv-bf96d37b.jpg";